import {GotchaEntryTypeVo} from '../../common/shared/api/nicolas/vo/enums/GotchaEntryTypeVo.enum';
import {GotchaEntryType} from '../generated/types';

export function createGotchaEntryType(
  entryEntryTypeVo: GotchaEntryTypeVo
): GotchaEntryType {
  return mapper[entryEntryTypeVo];
}

const mapper: {[key in GotchaEntryTypeVo]: GotchaEntryType} = {
  [GotchaEntryTypeVo.None]: GotchaEntryType.None,
  [GotchaEntryTypeVo.CashSponsorAd]: GotchaEntryType.CashSponsorAd,
  [GotchaEntryTypeVo.Redeem]: GotchaEntryType.Redeem,
  [GotchaEntryTypeVo.Direct]: GotchaEntryType.Direct,
};
